/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import bs58 from 'bs58'

// Hooks
import { useAppKitProvider } from '@reown/appkit/react'

// Components
import { Button } from 'views/components'

function SolanaProvider(props) {
  const { messageToSign, setSignature, isLoading } = props
  const { walletProvider } = useAppKitProvider('solana') // Namespace for Solana

  const handleSignSol = async () => {
    try {
      // Solana's signMessage typically expects a Uint8Array
      const msg = String.raw`${messageToSign}`
      const encodedMessage = new TextEncoder().encode(msg)
      const signature = await walletProvider.signMessage(encodedMessage)

      if (setSignature) {
        setSignature(bs58.encode(signature))
      }

      // console.log('SOL Signature (Hex):', Buffer.from(signature).toString('hex'))
    } catch (error) {
      console.error('Error signing SOL message:', error)
    }
  }

  return (
    <Button fullWidth type="button" onClick={handleSignSol} disabled={isLoading}>
      {isLoading ? 'Loading...' : 'Sign SOL Message'}
    </Button>
  )
}

// Default Props
SolanaProvider.defaultProps = {
  addressVerificationDetails: {},
}

// Proptypes Validation
SolanaProvider.propTypes = {
  addressVerificationDetails: PropTypes.shape({
    symbol: PropTypes.string,
    address: PropTypes.string,
    chain: PropTypes.string,
    created: PropTypes.string,
  }),
}

export default SolanaProvider
